import { useEffect } from 'react';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function PFSRealtyPortfolio() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans selection:bg-gray-200 selection:text-black">
      <title>PFS Realty | Real Estate Miami & South Florida | Mood Agency</title>
      <meta name="description" content="Caso de éxito PFS Realty: Desarrollo web en Vue/Nuxt con más de 60,000 propiedades, búsqueda en tiempo real con Typesense y analíticas avanzadas." />
      <meta name="keywords" content="PFS Realty, Miami, Real Estate, Vue, Nuxt, Typesense, WordPress, Cube.js, Desarrollo Web, MLS" />

      <Navbar />

      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden bg-white">
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
          <div className="absolute w-[60vw] h-[60vw] bg-[radial-gradient(circle,var(--tw-gradient-stops))] from-gray-200 via-gray-100/50 to-transparent rounded-full blur-[80px] opacity-100 z-0"></div>
          <div className="w-[90vw] h-[90vw] border border-gray-200 rounded-full absolute opacity-40"></div>
          <div className="w-[70vw] h-[70vw] border border-gray-300 rounded-full absolute opacity-50"></div>
          <div className="w-[50vw] h-[50vw] border border-gray-300 rounded-full absolute opacity-60"></div>
        </div>

        <div className="relative z-10 container mx-auto px-6 text-center">
          <div className="mb-8 animate-fade-in-up">
            <span className="font-display text-[10px] tracking-[0.4em] text-gray-400 uppercase">
              CASO DE ÉXITO
            </span>
          </div>

          <h1 className="font-display text-[12vw] md:text-[8vw] leading-none font-bold uppercase tracking-tighter text-gray-900 mb-8 animate-fade-in-up delay-100">
            PFS REALTY
          </h1>

          <p className="max-w-2xl mx-auto font-sans text-xl text-gray-500 font-light leading-relaxed animate-fade-in-up delay-200">
            Innovación inmobiliaria en Miami: 60,000+ propiedades con búsqueda instantánea y analítica avanzada.
          </p>
        </div>
      </section>

      {/* Key Metrics */}
      <section className="py-20 px-6 bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">60k+</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Propiedades</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">&lt;50ms</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Latencia de Búsqueda</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">MLS</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Integración Múltiple</p>
          </div>
        </div>
      </section>

      {/* The Context */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mb-12 uppercase">El Desafío</h2>
          <p className="font-sans text-xl md:text-2xl text-gray-500 leading-relaxed font-light">
            Gestionar y presentar más de 60,000 propiedades del sur de la Florida, unificando datos de múltiples orígenes MLS, manteniendo una experiencia de usuario fluida y optimizada para SEO.
          </p>
        </div>
      </section>

      {/* Technologies & Solution */}
      <section className="py-32 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-20 items-center">
            <div>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 mb-8 uppercase leading-tight">
              Tecnología<br/>de Punta
            </h2>
            <p className="font-sans text-lg text-gray-500 leading-relaxed mb-12">
              Implementamos una arquitectura robusta utilizando Vue y Nuxt para el frontend, garantizando velocidad y SEO. La integración con WordPress permite una gestión de contenidos flexible para nuevos proyectos.
            </p>
          </div>
          <div className="space-y-12">
             <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Typesense Search</h3>
              <p className="font-sans text-gray-500">Búsquedas instantáneas con latencia de milisegundos para miles de propiedades.</p>
            </div>
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Cube.js Analytics</h3>
              <p className="font-sans text-gray-500">Analíticas detalladas y estadísticas sobre edificios y departamentos para el usuario final.</p>
            </div>
             <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">MLS Data Enrichment</h3>
              <p className="font-sans text-gray-500">Proceso de enriquecimiento de datos provenientes de múltiples fuentes del MLS.</p>
            </div>
             <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Cloud Infrastructure</h3>
              <p className="font-sans text-gray-500">Frontend desplegado en Vercel para máxima velocidad y Railway para orquestar la preparación y procesamiento de datos.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Ecosystem & Infrastructure */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="mb-20">
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 uppercase">Ecosistema & Infraestructura</h2>
          </div>

          <div className="grid md:grid-cols-2 gap-px bg-gray-200 border border-gray-200">
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Actualización Constante</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Sincronización frecuente de propiedades para garantizar la disponibilidad y precisión de los datos mostrados al usuario final en tiempo real.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Marketing Automation</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Integración nativa con HubSpot y GoHighLevel, facilitando la gestión de leads, automatización y campañas para el equipo de marketing.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Soporte Multi-idioma</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Plataforma con soporte integral para localización y traducción, adaptándose a audiencias internacionales y mercados globales.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Gestión Eficiente</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Un entorno de trabajo optimizado que permite al equipo de marketing administrar proyectos y contenidos con total autonomía y facilidad.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
